(function () {
  'use strict';
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const data = JSON.parse(root.querySelector('[data-guide-data]').textContent);
    const s = data.strings, form = root.querySelector('form'), result = root.querySelector('[data-guide-result]');
    const error = root.querySelector('[data-guide-error]'), next = root.querySelector('[data-next]'), back = root.querySelector('[data-back]');
    const money = value => new Intl.NumberFormat(data.locale, { style: 'currency', currency: data.currency }).format(value / 100);
    let step = 0, selection;
    const needs = { visage: ['hydratation', 'nettoyage'], cheveux: ['secs', 'abimes', 'colores', 'blonds'], corps: ['apres-effort'] };
    function el(tag, cls, text) { const n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; }
    function showStep() {
      form.hidden = false; result.hidden = true; error.textContent = '';
      root.querySelectorAll('[data-guide-step]').forEach((n, i) => n.hidden = i !== step);
      root.querySelectorAll('.smz-progress span').forEach((n, i) => n.classList.toggle('active', i <= step));
      root.querySelector('[data-step-label]').textContent = s.step_label.replace('{{ number }}', String(step + 1));
      back.hidden = step === 0; next.textContent = step === 2 ? s.results : s.next;
    }
    function fillNeeds(universe) {
      const target = root.querySelector('[data-needs]'); target.replaceChildren();
      needs[universe].forEach(value => {
        const label = el('label'), input = el('input'); input.type = 'radio'; input.name = 'need'; input.value = value;
        label.append(input, document.createTextNode(s[value.replace('-', '_')])); target.append(label);
      });
    }
    form.addEventListener('change', e => { if (e.target.name === 'universe') fillNeeds(e.target.value); });
    back.addEventListener('click', () => { step = Math.max(0, step - 1); showStep(); });
    form.addEventListener('submit', e => {
      e.preventDefault(); const answers = Object.fromEntries(new FormData(form));
      if ((step === 0 && !answers.universe) || (step === 1 && !answers.need)) { error.textContent = s.guide_error; return; }
      if (step < 2) { step++; showStep(); root.querySelector('[data-guide-step="' + step + '"] input, [data-guide-step="' + step + '"] select')?.focus(); return; }
      selection = window.SMZ_ROUTINES.recommend(answers, data.products);
      if (selection.error) { error.textContent = s.guide_error; return; }
      result.replaceChildren(); form.hidden = true; result.hidden = false;
      const title = el('h3', '', s[answers.need.replace('-', '_')]); title.tabIndex = -1; result.append(title);
      result.append(el('p', '', s[answers.mode]));
      if (selection.adjusted) result.append(el('p', 'smz-notice', s.adjusted));
      if (selection.missing.length) result.append(el('p', 'smz-notice', s.missing));
      if (selection.products.length) {
        const grid = el('div', 'smz-product-grid');
        selection.products.forEach(p => {
          const card = el('article', 'smz-card'), link = el('a', 'smz-card-image'); link.href = p.url;
          if (p.image) { const img = el('img'); img.src = p.image; img.alt = p.title; img.loading = 'lazy'; img.width = 500; img.height = 500; link.append(img); }
          const content = el('div', 'smz-card-content'); content.append(el('h4', '', p.title), el('p', 'smz-price', money(p.priceCents)));
          const cta = el('a', 'smz-button smz-button-outline', s.view_product); cta.href = p.url; content.append(cta); card.append(link, content); grid.append(card);
        });
        result.append(grid, el('p', 'smz-total', s.selection_total + ' : ' + money(selection.total)));
      } else result.append(el('p', 'smz-notice', s.no_match));
      result.append(el('p', '', answers.sensitive ? s.sensitive_note : s.precautions));
      const actions = el('div', 'smz-actions'), status = el('p'); status.setAttribute('role', 'alert');
      if (selection.products.length) {
        const add = el('button', 'smz-button', s.add_routine); add.type = 'button';
        add.addEventListener('click', async () => {
          add.disabled = true; add.textContent = s.adding; status.textContent = '';
          let added = false;
          try {
            const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
            const request = { items: selection.products.map(p => ({ id: p.variantId, quantity: 1 })) };
            if (cart && typeof cart.getSectionsToRender === 'function') {
              request.sections = cart.getSectionsToRender().map(section => section.id);
              request.sections_url = window.location.pathname;
              if (typeof cart.setActiveElement === 'function') cart.setActiveElement(add);
            }
            const response = await fetch(data.cartAddUrl, {
              method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify(request)
            });
            const payload = await response.json();
            if (!response.ok) throw new Error(payload.description || s.cart_error);
            added = true;
            if (cart && typeof cart.renderContents === 'function' && payload.sections && Object.values(payload.sections).every(Boolean)) {
              cart.classList.remove('is-empty');
              cart.renderContents(payload);
              add.textContent = s.added_routine;
              status.textContent = s.added_routine;
            } else window.location.assign(data.cartUrl);
          } catch (err) {
            if (added) { window.location.assign(data.cartUrl); return; }
            status.textContent = s.cart_error; add.disabled = false; add.textContent = s.add_routine;
          }
        }); actions.append(add);
      }
      const reset = el('button', 'smz-button smz-button-outline', s.reset); reset.type = 'button';
      reset.addEventListener('click', () => { step = 0; showStep(); form.querySelector('[name="universe"]')?.focus(); }); actions.append(reset); result.append(actions, status); title.focus();
    });
    showStep();
  }
  function start() { document.querySelectorAll('[data-smz-guide]').forEach(init); }
  document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', start);
  if (document.readyState !== 'loading') start();
})();
